<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/logo/login_logo.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <validation-observer v-slot="{required}">
                  <form>
                    <div class="vx-col block lg:hidden lg:w-1/2">
                      <img src="@/assets/images/logo/login_logo.png" alt="Intelliprice" class="mx-auto" style="width:220px; margin-left: auto; margin-right: auto; margin-top: 40px;">
                    </div>
                    <div class="vx-col sm:w-full md:w-full ml-auto mr-auto d-theme-dark-bg">
                      <div class="py-20 px-10 login-tabs-container">
                        <div class="vx-card__title mb-4">
                          <h4 class="mb-6">Σύνδεση</h4>
                        </div>
                        <div>
                          <validation-provider rules="required|min:6" v-slot="{errors}">
                            <vs-input
                                name="username"
                                icon-no-border
                                icon="icon icon-user"
                                icon-pack="feather"
                                label-placeholder="Όνομα χρήστη"
                                v-model="email"
                                class="w-full"/>
                            <span class="text-danger text-sm">{{ errors[0] }}</span>
                          </validation-provider>

                          <validation-provider rules="required|min:6|max:10" v-slot="{errors}">
                            <vs-input
                                type="password"
                                name="password"
                                icon-no-border
                                icon="icon icon-lock"
                                icon-pack="feather"
                                label-placeholder="Κωδικός"
                                v-model="password"
                                @keyup.enter="loginJWT"
                                class="w-full mt-6"/>

                            <span class="text-danger text-sm">{{ errors[0] }}</span>
                          </validation-provider>

                          <div class="flex flex-wrap justify-between my-5">
                            <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Να με θυμάσαι</vs-checkbox>
                            <router-link to="recovery">Επαναφορά κωδικού</router-link>
                          </div>
                          <vs-button :disabled="required" @click="loginJWT">Σύνδεση</vs-button>
                        </div>
                      </div>
                    </div>
                  </form>
                </validation-observer>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>

</template>

<script>
import {ValidationObserver, ValidationProvider, extend} from 'vee-validate'
import {required, length, max } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο'
})

extend('length', {
  ...length,
  message: 'Πρέπει να περιέχει 6 χαρακτήρες'
})

extend('max', {
  ...max,
  message: 'Επιτρέπονται έως 10 χαρακτήρες'
})

export default {
  name: 'Login',
  components: {
    ValidationObserver, ValidationProvider
  },
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
    }
  },
  mounted() {
    let rememberObject = localStorage.getItem('rememberObject');
    if (rememberObject) {
      let jsonObject = JSON.parse(rememberObject);
      this.email = jsonObject.email;
      this.password = jsonObject.password;
      this.checkbox_remember_me = true;
    }
  },
  methods: {
    checkLogin() {
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      return true
    },
    loginJWT() {
      if (!this.checkLogin()) return
      this.$vs.loading()
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        }
      }

      if (this.checkbox_remember_me) {
        var rememberObject = {"email": this.email, "password": this.password};
        localStorage.setItem('rememberObject', JSON.stringify(rememberObject))
      } else {
        localStorage.removeItem('rememberObject')
      }

      this.$store.dispatch('auth/loginJWT', payload)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(error => {
            let errorMessage = ''
            //let errorCaption = error.response.data.error
            //switch (errorCaption) {
            //  case 'invalid_credentials':
                errorMessage = 'Ελέγξτε τα στοιχεία είσοδου και προσπαθείστε πάλι!'
            //    break
            //  case 'could_not_create_token':
            //    errorMessage = `
            //    Προσωρινό πρόβλημε με το διακομιστή.
            //    Προσπαθείστε πάλι.
            //    Αν το πρόβλημα συνεχιστεί επικοινωνείστε με τον διαχειριστή της εφαμρογής.`
            //    break
            //}
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Λάθος',
              text: errorMessage,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
    }
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }
}
.login-tabs-container {
  min-height: 405px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
